module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selected.vessel.id) ? _c('img', {
    class: ['vslimg', {
      'fade-in-animation': _vm.imageLoaded
    }],
    attrs: {
      "src": _vm.im,
      "alt": _vm.selected.vessel.name
    },
    on: {
      "load": _vm.onImageLoad
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-521ca2cf!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/fleet/components/Images.vue
// module id = 175
// module chunks = 3